import {apiSlice} from '../apiSlice';

const REPORT_URL = '/reports';

export const reportApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        newAxis: builder.mutation({
            query: ({id, token, page, perPage, startDate, endDate, resolution}) => ({
                url: `${REPORT_URL}/axis/${id}`,
                method: 'POST',
                headers: {
                    'x-access-token': token,
                },
                params: {
                    page,
                    perPage,
                    startDate,
                    endDate,
                    resolution
                },
            }),
        }),
        newIdleFuel: builder.mutation({
            query: ({id, token, startDate, page, perPage, endDate, resolution}) => ({
                url: `${REPORT_URL}/idleFuel/${id}`,
                method: 'POST',
                headers: {
                    'x-access-token': token,
                },
                params: {
                    page,
                    perPage,
                    startDate,
                    endDate,
                    resolution
                },
            }),
        }),
        newAlarmReport: builder.mutation({
            query: ({id, token, startDate, endDate, all}) => ({
                url: `${REPORT_URL}/teltaleCountDetail`,
                method: 'POST',
                headers: {
                    'x-access-token': token,
                },
                params: {
                    id,
                    startDate,
                    endDate,
                    all
                },
            }),
        }),
        newIdleIgnitionReport: builder.mutation({
            query: ({id, token, startDate, endDate, resolution}) => ({
                url: `${REPORT_URL}/idleIgnition/${id}`,
                method: 'POST',
                headers: {
                    'x-access-token': token,
                },
                params: {
                    startDate,
                    endDate,
                    resolution
                },
            }),
        }),
        newIdleSummaryReport: builder.mutation({
            query: ({id, token, startDate, endDate}) => ({
                url: `${REPORT_URL}/idleSummary/${id}`,
                method: 'POST',
                headers: {
                    'x-access-token': token,
                },
                params: {
                    startDate,
                    endDate,
                },
            }),
        }),
        newIdleRouteReport: builder.mutation({
            query: ({id, token, startDate, endDate, resolution, map}) => ({
                url: `${REPORT_URL}/idleRoute/${id}`,
                method: 'POST',
                headers: {
                    'x-access-token': token,
                },
                params: {
                    startDate,
                    endDate,
                    resolution,
                    map
                },
            }),
        }),
        newFmsLogReport: builder.mutation({
            query: ({id, token, list, page, perPage, startDate, endDate, resolution}) => ({
                url: `${REPORT_URL}/fmsLogReport/${id}`,
                method: 'POST',
                headers: {
                    "x-access-token": token
                },
                body: {
                    list
                },
                params: {
                    page,
                    perPage,
                    startDate,
                    endDate,
                    resolution
                }
            }),
        }),
        newFmsLogReportFull: builder.mutation({
            query: ({id, token, page, perPage, startDate, endDate}) => ({
                url: `${REPORT_URL}/canBusFullReport/${id}`,
                method: 'POST',
                headers: {
                    "x-access-token": token
                },
                params: {
                    page,
                    perPage,
                    startDate,
                    endDate
                }
            }),
        }),
        newCreateCanBusReportFull: builder.mutation({
            query: ({id, token, startDate, endDate}) => ({
                url: `${REPORT_URL}/createCanBusReport/${id}`,
                method: 'POST',
                headers: {
                    "x-access-token": token
                },
                params: {
                    startDate,
                    endDate
                }
            }),
        }),
        getManagerReport: builder.query({
            query: (token) => ({
                url: `${REPORT_URL}/managerReport`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            })
        }),
    }),
});

export const {
    useGetManagerReportQuery,
    useNewFmsLogReportMutation,
    useNewIdleIgnitionReportMutation,
    useNewIdleSummaryReportMutation,
    useNewIdleRouteReportMutation,
    useNewFmsLogReportFullMutation,
    useNewAxisMutation,
    useNewAlarmReportMutation,
    useNewIdleFuelMutation,
} = reportApiSlice;
